// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import UpCircleTwoToneSvg from "@fishx/icons-svg/es/asn/UpCircleTwoTone";
import FishxIcon from '../components/FishxIcon';

var UpCircleTwoTone = function UpCircleTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: UpCircleTwoToneSvg
  }));
};

UpCircleTwoTone.displayName = 'UpCircleTwoTone';
export default React.forwardRef(UpCircleTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/UpCircleTwoTone.js
// module id = 4317
// module chunks = 0